export default __webpack_public_path__ + "static/media/statusDefault.c11b5cc1.svg";